import React, { useState } from "react";
import TwoDView from "./TwoDView";
import DownloadIcon from "../../assets/svg/download 1.svg";
import ThreeDView from "./ThreeDView";

const DesignView = () => {
  const [view, setView] = useState("2D");

  const handleView = (type) => {
    setView(type);
  };

  return (
    <div>
      <div className="container mx-auto mt-3 ">
        <div>{view === "2D" ? <TwoDView /> : <ThreeDView />}</div>
        <div className="flex p-4 absolute bottom-0 left-0 right-0 md:p-0 md:relative justify-between my-3">
          <div className="flex border border-[#D0D0D0] rounded-[15px] p-1">
            <div
              onClick={() => handleView("2D")}
              className={`${
                view === "2D" ? "bg-red-600 text-white" : "text-[#5D5D5D]"
              } rounded-s-[15px] px-3 py-2 cursor-pointer text-sm font-semibold`}
            >
              2D
            </div>
            <div
              onClick={() => handleView("3D")}
              className={`${
                view === "3D" ? "bg-red-600 text-white" : "text-[#5D5D5D]"
              } rounded-e-[15px] px-3 cursor-pointer py-2 text-sm font-semibold`}
            >
              3D
            </div>
          </div>

          <div className="flex gap-4 ">
            <button className="border border-[#C2C2C2] p-3 rounded-full">
              <img src={DownloadIcon} alt="" />
            </button>

            <button className="bg-red-600 px-4 py-2 text-lg font-semibold text-white rounded-[40px]">
              Cost Plans
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesignView;
